var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3493 18.6546C10.9802 18.9859 10.5001 19.1684 10.0029 19.1666C9.50569 19.1648 9.02701 18.9788 8.66038 18.6449L8.55122 18.5458C3.30226 13.835 -0.126329 10.7509 0.00356684 6.90327C0.0337756 6.06214 0.260952 5.23961 0.667034 4.50109C1.07312 3.76256 1.6469 3.1284 2.34278 2.64902C3.53061 1.8628 4.96826 1.53941 6.38084 1.74068C7.79342 1.94194 9.08183 2.65374 9.99972 3.73998C11.759 1.69696 15.0176 0.854138 17.6567 2.64902C18.3525 3.1284 18.9263 3.76256 19.3324 4.50109C19.7385 5.23961 19.9657 6.06214 19.9959 6.90327C20.136 10.7509 16.6972 13.835 11.4493 18.5653L11.3493 18.6546V18.6546Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.4a123565047056d576d3150bca8c7f08.svg";
export { ForwardRef as ReactComponent };